import LegalPage from "../components/LegalPage";
import { termsOfServiceContent } from "../data/legalContent";

const TermsPage = () => {
  return <LegalPage pageTestId="terms-page" {...termsOfServiceContent} />;
};

export default TermsPage;